import {AbstractTaskHandler} from "./AbstractTaskHandler";
import TakipXmlParser from "../../../takip_ac/TakipXmlParser";
import UyapTakipAc from "../../../takip_ac/UyapTakipAc";
import {TaskDurum} from "../../../enum/TaskDurum";
import {ITask} from "../GorevYoneticisiTypes";
import app from "@/main";

export class UyapTakipOdemeYapTaskHandler extends AbstractTaskHandler {
    async handle(task: ITask): Promise<ITask> {
        try {
            let takip: UyapTakipAc = UyapTakipAc.fromJson(task.data);
            let uyapDosya = await app.$uyap.TamamlanmayanDosyaBul().run({
                birimId: task.birim_id,
                acilisTime: new Date(task.uyap_dosya_acilis_tarihi).getTime(),
                dosyaAcilisTarihi: task.uyap_dosya_acilis_tarihi
            });
            console.log('uyapDosya',uyapDosya);
            task.dosya_id = uyapDosya.dosyaID;
            takip.dosyaGuncelle(uyapDosya);
            if (takip.isEicraprodanmiAcilmis()) {
                console.log("EICRAPRODAN ACILMIS !!");
                takip.parsedFile = TakipXmlParser.fromJson(task.data.parsedFile);
                await takip.takipAc();
            } else {
                console.log("UYAPTAN ACILMIS !!");
                await takip.tamamlanmamisDosyaTakipAc();
            }
            task.response = takip;
            // UYAP'ta takip açıldı ama kart güncellenemediyse görev eksik biter.
            task.status = takip.icraProSenkronHatasi ? TaskDurum.BITTI_EKSIK : TaskDurum.BITTI_BASARILI;
            return task;
        } catch (e) {
            console.log(e);
            throw new Error(e.message)
        }
    }

}